import React from "react";
import _noop from "lodash/noop";
import OriginModal from "react-bootstrap/Modal";

import { useModalStore } from "@/store/hooks";

const Modal = ({ children, onHide = _noop, ...restProps }) => {
  const { closeModal } = useModalStore();

  function handleHide() {
    onHide();
    closeModal();
  }

  return (
    <OriginModal
      backdrop={false}
      container={document.getElementById("root")}
      onHide={handleHide}
      show={true}
      {...restProps}
    >
      {children}
    </OriginModal>
  );
};

Modal.Header = ({ children, ...restProps }) => {
  return (
    <OriginModal.Header closeButton {...restProps}>
      {children}
    </OriginModal.Header>
  );
};
Modal.Body = OriginModal.Body;
Modal.Footer = OriginModal.Footer;

export default Modal;
